import { Card, Tooltip } from '@bancobarigui/barihaus';
import { FileSearchOutlined, RightOutlined } from '@ant-design/icons';

import { DASHBOARD_COLOR_CLASSES, DASHBOARD_ICON_MAP } from '@/shared/constants/dashboardStyles';
import { DashboardCard as DashboardCardType } from '../types';

interface DashboardCardProps {
  card: DashboardCardType;
  onClick?: (cardId: string) => void;
}

export function DashboardCard({ card, onClick }: DashboardCardProps) {
  const colors = DASHBOARD_COLOR_CLASSES[card.color] || DASHBOARD_COLOR_CLASSES.gray;
  const icon = DASHBOARD_ICON_MAP[card.icon] || <FileSearchOutlined />;

  const handleClick = () => {
    onClick?.(card.id);
  };

  return (
    <Card
      className={`
        cursor-pointer transition-all duration-200 border border-gray-200 rounded-xl h-full w-full
        !min-w-0 !overflow-hidden
        ${colors.hover}
      `}
      style={{ minWidth: 0, width: '100%', overflow: 'hidden' }}
      bodyStyle={{ padding: 0, height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}
      onClick={handleClick}
    >
      <div className={`${colors.bg} px-3 py-2.5 rounded-t-xl`}>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2 min-w-0 flex-1">
            <div className={`${colors.icon} p-2 rounded-lg text-base`}>
              {icon}
            </div>
            <div className="min-w-0">
              <h3 className="font-medium text-gray-700 m-0 leading-tight truncate" style={{ fontSize: 16 }}>
                {card.title}
              </h3>
            </div>
          </div>
          <Tooltip title="Ver detalhes">
            <div className="text-gray-400 hover:text-gray-600 transition-colors">
              <RightOutlined className="text-xs" />
            </div>
          </Tooltip>
        </div>
      </div>

      <div className="px-3 py-2.5 border-b border-gray-100">
        <div className="flex items-baseline gap-1.5">
          <span className="font-bold text-gray-800" style={{ fontSize: 32 }}>
            {card.total}
          </span>
          <span className="text-xs text-gray-500">
            {card.total === 1 ? 'item' : 'itens'}
          </span>
        </div>
      </div>

      <div className="px-3 py-2 flex-1">
        <ul className="m-0 p-0 list-none space-y-1.5">
          {card.countsByDate.map((item, index) => (
            <li
              key={index}
              className={`
                flex items-center justify-between text-sm
                ${item.isOld ? 'text-red-600' : 'text-gray-600'}
              `}
            >
              <span className="flex items-center gap-1.5">
                <span
                  className={`
                    w-1.5 h-1.5 rounded-full
                    ${item.isOld ? 'bg-red-400' : colors.badge}
                  `}
                />
                <span className="truncate">{item.label}</span>
              </span>
              <span className={`font-semibold ${item.isOld ? 'text-red-600' : 'text-gray-800'}`}>
                {item.count}
              </span>
            </li>
          ))}
        </ul>
      </div>

    </Card>
  );
}
